import React from 'react';

/**
 * The red line across a day's trips that says where the clock has got to:
 * everything before it has already started, everything after is still ahead.
 *
 * ONE COMPONENT, THREE SCREENS. The office's Daily Overview, the dispatch
 * board and the driver's own day all draw the same marker; where it may
 * appear and between which two rows is `Utils/nowMarker`'s single rule, and
 * the words are each screen's own copy object (English on the staff
 * screens, Hungarian in the driver portal). Nothing about it is written
 * twice.
 *
 * TWO DESIGN SYSTEMS, THOUGH. The dashboard is Bootstrap with literal
 * colours; the portal is scoped under `.pp-root` with custom properties
 * that resolve to NOTHING outside that scope (and vice versa). So the
 * component takes the block class it should wear — `dov-now` on the
 * dashboard, `pp-now` in the portal — and each stylesheet owns its own
 * palette AND its own orientation for it: across a list in the portal,
 * standing up through the lanes of the office's day timeline.
 * `src/__tests__/unit/portalStyles.test.js` pins both, compiled from the
 * real stylesheets, because a marker drawn in a token that is not in scope
 * is invisible on the screen and perfect in jsdom.
 *
 * It is a SEPARATOR, not a row and not an alert: `role="separator"` keeps
 * it out of the list of trips for a screen reader, and its accessible name
 * is the label and the time ("Now 14:05"), so it reads as a clock rather
 * than as something wrong with a booking.
 */
export const NOW_LINE_DASH = 'dov-now';
export const NOW_LINE_PORTAL = 'pp-now';

function NowLine({ block, label, time }) {
  return (
    <div className={block} role="separator" aria-label={`${label} ${time}`}>
      <span className={`${block}__dot`} />
      <span className={`${block}__time`}>{time}</span>
      <span className={`${block}__line`} />
      <span className={`${block}__label`}>{label}</span>
    </div>
  );
}

export default NowLine;
